<!--
 * @Author: xinian
 * @Date: 2022-03-28 09:15:31
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-22 15:28:32
 * @FilePath: \xm-cms\src\App.vue
-->
<template>
  <router-view />
</template>

<style lang="scss">
body,
html {
  margin: 0px;
  padding: 0px;
}
</style>
